
import { Options, Vue } from 'vue-class-component';
import HelloWorld from '../../components/HelloWorld.vue';
import { DataUtil } from '@/util/DataUtil';
import { userPrivacyConfigHJLL } from "@/config/template_new_user_privacy_hjll";

@Options({
    components: {
        HelloWorld,
    }
})
export default class App extends Vue {

    private temp: string = userPrivacyConfigHJLL.template_new_protocol_20230926;

    private config: TemplateInterface = {
        productName: '好剧连连',
        companyFullName: '海南耀天网络技术有限公司',
        companyShortName: '海南耀天',
        officialWebsite: 'http://yaotkj.com/',
        mail: "2581786904@qq.com",
        cashConfig: ``
    };

    mounted() {
        this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
}
